import React from 'react';

const Image = (props) => {
    return <img {...props} src={`/assets/images/${props.src}`} />;
};

export default Image;
